import { useMutation, useQueryClient } from "@tanstack/react-query";
import { WorkOrder, WorkOrderInput } from "../type/WorkOrder";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { GET_WORK_ORDERS_FETCH_KEY } from "./useGetWorkOrder";

export const updateWorkOrder = async (
  id: string,
  updatedWorkOrder: WorkOrderInput,
): Promise<WorkOrder> => {
  const response = await fetcher.put<WorkOrder>(
    `${API.GESLUB}/workOrders/${id}`,
    updatedWorkOrder,
  );
  return response.data;
};

export const useUpdateWorkOrder = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    WorkOrder,
    Error,
    { id: string; updatedWorkOrder: WorkOrderInput }
  >({
    mutationFn: async ({ id, updatedWorkOrder }) => {
      return updateWorkOrder(id, updatedWorkOrder);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_WORK_ORDERS_FETCH_KEY] });
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
